import { getBrandLogoPathFromKvpsIdentifier } from "@/lib/kvps";

import { RetailCtmSummaryPdfDocument } from "./builder";
import {
  buildRetailCtmSummaryPdfFilename,
  formatRetailCtmPdfDate,
  formatRetailCtmPdfDateTime,
  formatRetailCtmPdfTradeIn,
  formatRetailCtmPdfYesNo,
  toPdfDisplayValue,
} from "./formatters";
import { loadRetailCtmPdfBrandLogo, loadRetailCtmPdfIcons } from "./icons";
import type { RetailCtmSummaryPdfData } from "./types";

export type { RetailCtmSummaryPdfData } from "./types";

export {
  buildRetailCtmSummaryPdfFilename,
  formatRetailCtmPdfDate,
  formatRetailCtmPdfDateTime,
  formatRetailCtmPdfTradeIn,
  formatRetailCtmPdfYesNo,
  toPdfDisplayValue,
};

export async function downloadRetailCtmSummaryPdf(
  data: RetailCtmSummaryPdfData,
  options?: { filename?: string },
): Promise<void> {
  const generatedAt = new Date();
  const [icons, brandLogo] = await Promise.all([
    loadRetailCtmPdfIcons(),
    loadRetailCtmPdfBrandLogo(
      getBrandLogoPathFromKvpsIdentifier(data.kvpsIdentifier),
    ),
  ]);

  const pdf = new RetailCtmSummaryPdfDocument(icons).render(
    data,
    brandLogo,
    generatedAt,
  );
  pdf.save(
    options?.filename ??
      buildRetailCtmSummaryPdfFilename(
        data.vehicle.commissionNumber,
        data.vehicle.commissionYear,
        generatedAt,
      ),
  );
}
